import { createIntl, createIntlCache, IntlConfig } from 'react-intl'
import { messages } from 'app/localization'
import { defaultRichTextElements } from './defaultRichTextElements'

export const DEFAULT_LOCALE = 'en'

export function createAppIntl(props?: Partial<IntlConfig>) {
  const cache = createIntlCache()

  const intl = createIntl(
    {
      locale: DEFAULT_LOCALE,
      messages: messages[DEFAULT_LOCALE],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      defaultRichTextElements: defaultRichTextElements as any,
      ...props
    },
    cache
  )
  return intl
}

const intl = createAppIntl()

export default intl
